export default "https://assets.egbcdn.net/assets/packs/_/images/app/manual/manual4-a9a7dda9023349722bc25f8700b80521.png";